import * as Yup from "yup";
import {
  maxDateToDayField,
  minLength,
  requiredField,
} from "../../../../shared/helpers/getMessageValidation";
import {
  addresSchema,
  contactSchema,
  personSchema,
} from "../firstStep/validationSchema";
import {
  academicEducationsSchema,
  languages,
  techResource,
} from "../secondStep/validationSchema";

const jobExperiencesSchema = Yup.object({
  jobPlace: Yup.string().required(requiredField()),
  jobFunction: Yup.string()
    .required(requiredField())
    .typeError(requiredField()),
  startDate: Yup.date()
    .required(requiredField())
    .max(new Date(Date.now()), maxDateToDayField()),
  endDate: Yup.date().max(new Date(Date.now()), maxDateToDayField()).nullable(),
  tasks: Yup.string().required(requiredField()),
});

const referredsSchema = Yup.object({
  document: Yup.string().trim().min(8, minLength(8)).matches(/^[0-9,M,F,f,m]+$/, 'Este campo solo admite números y la letra M y F'),
});

export const getSchemaValidationThirdStep = () => {
  const thirdStepValidation = Yup.object({
    person: personSchema,
    address: addresSchema,
    contactInformation: contactSchema,
    academicEducations: Yup.array().of(academicEducationsSchema),
    languages: Yup.array().of(languages),
    techResource,
    jobExperiences: Yup.array().of(jobExperiencesSchema),
    referreds:  Yup.array().of(referredsSchema),
  });
  return thirdStepValidation;
};
